import { ProgressSpinner } from 'primereact/progressspinner';
import React, { Component } from 'react';

class RadialProgressBar extends Component<Props, State> {
  public state = new State();

  public render() {
    const { normalizedScore } = this.state;
    const { progressColor, labelColor, loading, maxScore } = this.props;
    return (
      <div className='flex flex-col items-center gap-y-4 justify-center'>
        <div className='relative flex h-24 w-48 2xl:h-24 2xl:w-64 items-center justify-center overflow-hidden '>
          <div
            className={`absolute left-[0.35rem] 2xl:left-[1.725rem] top-[0.5rem]  2xl:top-[0.125rem] 2xl:h-[12.725rem] 2xl:w-[12.725rem] h-[11.25rem] w-[11.25rem] dotted-circle-progress rotate-[280deg] transition-all  rounded-full border-[4px] `}
          />
          <div
            id={'radial-progress'}
            style={{ rotate: normalizedScore + 'deg' }}
            className={`absolute ${maxScore > 0 ? 'after:visible' : 'after:hidden'} after:w-[1.25rem] 2xl:after:w-5 2xl:after:h-4 2xl:after:top-1.5  2xl:after:left-1 after:h-[1.25rem] after:rotate-[42deg] after:left-[0.075rem] after:absolute  after:rounded-t-[50%]  left-[1rem] 2xl:left-[2.35rem] top-[1rem] 2xl:top-[0.625rem] 2xl:h-[11.5rem] 2xl:w-[11.5rem] h-[10rem] w-[10rem] duration-400 transition-all ${progressColor} rounded-full border-[1.25rem] border-transparent border-r-[#EBECF1] border-t-[#EBECF1] `}
          />
          <h5 className={`z-50 numbers self-end text-4xl 2xl:text-4xl font-bold ${labelColor}`} data-testid={this.props['data-testid']}>
            {loading ? <ProgressSpinner style={{ height: 30, width: 30 }} /> : this.state.score}
          </h5>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    this.setInterval();
    this.setScoreInterval();
  }

  public componentWillUnmount() {
    clearInterval(this.state.scoreInterval);
    clearInterval(this.state.normalizedScoreInterval);
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.score !== this.props.score) {
      this.setInterval();
      this.setScoreInterval();
    }
  }

  private setInterval = () => {
    const normalizeScoreInterval = setInterval(() => {
      const { normalizedScore } = this.state;
      if (normalizedScore < this.normalizeScore()) {
        this.setState({ normalizedScore: normalizedScore + 1 });
      } else {
        clearInterval(normalizeScoreInterval);
      }
    }, 4);
    this.setState({ normalizedScoreInterval: normalizeScoreInterval });
  };

  private setScoreInterval = () => {
    const scoreInterval = setInterval(() => {
      const { score } = this.state;
      if (score < this.props.score) {
        this.setState({ score: score + 1 });
      } else {
        clearInterval(scoreInterval);
      }
    }, 0);
    this.setState({ scoreInterval });
  };

  private normalizeScore() {
    const { score, maxScore } = this.props;
    if (score > maxScore) return 135;
    if (maxScore > 0)
      return (score / maxScore) * 180 - 50; //Speedometer da border deg dönen değer -45 ile 135 arasında olmalı ve bu fonksiyon -45 ile 135 arasına değeri normalize eder!
    else return -45;
  }
}

interface Props {
  score: number;
  maxScore: number;
  progressColor: string;
  labelColor: string;
  loading?: boolean;
  'data-testid'?: string;
}

class State {
  scoreInterval: any = null;
  normalizedScoreInterval: any = null;
  normalizedScore: number = -45;
  score: number = 0;
}

export default RadialProgressBar;
